import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-vouchdialog',
  standalone: false,
  templateUrl: './vouchdialog.component.html',
  styleUrl: './vouchdialog.component.css'
})
export class VouchDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<VouchDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: UntypedFormGroup;
  isUpgrade: boolean = Boolean(this.data.isUpgrade);

  ngOnInit(): void {
    const required = [Validators.required, Validators.pattern(/\S/)];
    this.form = new UntypedFormGroup({
      identity: new UntypedFormControl('', this.isUpgrade ? [] : required),
      experience: new UntypedFormControl('', required),
      affiliationsDisclosed: new UntypedFormControl(false, Validators.requiredTrue)
    });
  }

  formatNote(): string {
    const parts: string[] = [];
    if (!this.isUpgrade) {
      parts.push(`Identity: ${this.form.value.identity.trim()}`);
    }
    parts.push(`Experience: ${this.form.value.experience.trim()}`);
    return parts.join(' | ');
  }

  cancel() {
    this.dialogRef.close(false);
  }

  async submit() {
    if (this.form.invalid) {
      return;
    }
    await this.data.callback(this.formatNote());
    this.dialogRef.close(true);
  }
}
